import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

const LangRedirect = () => {
  const [lang, setLang] = useState<string | null>(null);

  useEffect(() => {
    // Check stored preference first
    const stored = localStorage.getItem('preferred_lang');
    if (stored === 'en' || stored === 'ir') {
      setLang(stored);
      return;
    }

    // Try IP-based detection
    fetch('https://ipapi.co/json/')
      .then(r => r.json())
      .then(data => {
        const detectedLang = data.country_code === 'IR' ? 'ir' : 'en';
        localStorage.setItem('preferred_lang', detectedLang);
        setLang(detectedLang);
      })
      .catch(() => {
        setLang('ir');
      });
  }, []);

  if (!lang) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary" />
      </div>
    );
  }

  return <Navigate to={`/${lang}`} replace />;
};

export default LangRedirect;
